import axios from '@axios'

export default {
  // assembleia
  createAssembleia: assembleia => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias`,
    assembleia,
  ),
  listAssembleia: params => axios.get(`${process.env.VUE_APP_NOVITATUS_API}/assembleias`, {
    params,
  }),
  getAssembleia: assembleiaId => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}`,
  ),
  patchAssembleia: (assembleiaId, assembleia) => axios.patch(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}`,
    assembleia,
  ),
  // assembleia - item pauta
  createItemPauta: (assembleiaId, itemPauta) => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta`,
    itemPauta,
  ),
  listItemPauta: assembleiaId => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta`,
  ),
  getItemPauta: (assembleiaId, itemPautaId) => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}`,
  ),
  patchItemPauta: (assembleiaId, itemPautaId, itemPauta) => axios.patch(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}`,
    itemPauta,
  ),
  deleteItemPauta: (assembleiaId, itemPautaId) => axios.delete(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}`,
  ),
  // assembleia - participante
  listParticipante: (assembleiaId, params) => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/participantes`,
    {
      params,
    },
  ),
  // assembleia - item pauta - voto
  listVoto: (assembleiaId, itemPautaId, params) => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}/votos`,
    {
      params,
    },
  ),
  getVoto: (assembleiaId, itemPautaId, votoId) => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}/votos/${votoId}`,
  ),
  createVoto: (assembleiaId, itemPautaId, voto) => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}/votos`,
    voto,
  ),
  patchVoto: (assembleiaId, itemPautaId, voto) => axios.patch(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}/votos/${voto.id}`,
    voto,
  ),
  // assembleia - comentarios
  listComentario: (assembleiaId, params) => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/comentarios`,
    {
      params,
    },
  ),
  createComentario: (assembleiaId, comentario) => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/comentarios`,
    comentario,
  ),
  // assembleia - participantes
  createParticipante: (assembleiaId, participante) => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/participantes`,
    participante,
  ),
  // assembleia - opções de voto
  listOptionsVote: (assembleiaId, itemPautaId) => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}/opcoesvoto`,
  ),
  createOptionVote: (assembleiaId, itemPautaId, optionRq) => axios.post(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}/opcoesvoto`,
    optionRq,
  ),
  updateOptionVote: (assembleiaId, itemPautaId, optionVotoId, optionRq) => axios.patch(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}/opcoesvoto/${optionVotoId}`,
    optionRq,
  ),
  deleteOptionVote: (assembleiaId, itemPautaId, optionVotoId) => axios.delete(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/itenspauta/${itemPautaId}/opcoesvoto/${optionVotoId}`,
  ),
  // assembleia - resultados (apruração dos votos)
  listResultado: (assembleiaId, params) => axios.get(
    `${process.env.VUE_APP_NOVITATUS_API}/assembleias/${assembleiaId}/resultados`,
    {
      params,
    },
  ),
}
